import React from "react";
import { useNavigate } from "react-router-dom";
import BrandManagerShell from "./components/BrandManagerShell";
import { CLIENT_SUPPORT_HUB_PATH } from "./supportHubPaths";
import "./brandManagerPages.css";

/**
 * Brand Requests — production shell.
 *
 * CURRENT: no live Brand Request API / domain in this initiative.
 * Temporary Support escape hatch is available; Support is NOT the permanent architecture.
 *
 * FUTURE: Client requests a missing catalog Brand → canonical Brand Request record →
 * SA governance review → status visible to Client. Requires dedicated docs/code
 * reconciliation of BrandReviewRequest vs this product workflow before backend build.
 */
export default function BrandManagerBrandRequests() {
  const navigate = useNavigate();

  return (
    <BrandManagerShell>
      <div className="brand-manager-header">
        <h1>Brand Requests</h1>
        <p className="subtitle">
          Track requests for Brands that are not yet in the KrossKast catalog
        </p>
      </div>

      <div
        className="bm-page-panel"
        data-testid="brand-requests-page"
        data-requests-state="unavailable"
      >
        <p className="bm-page-lead">
          When a Brand is already in the platform catalog, add it from{" "}
          <strong>Add New Brand</strong> (portfolio enrollment). When it is
          not in the catalog, requesting it will eventually create a
          governance-reviewed Brand Request — that workflow is not live yet.
        </p>

        <div
          className="bm-unavailable"
          data-testid="brand-requests-empty-state"
        >
          <h2>Brand Request workflow not available yet</h2>
          <p>
            No request records are shown here. KrossKast does not fabricate
            Pending / Under Review / Approved / Declined rows.
          </p>
          <p className="bm-unavailable-note">
            Future dependency: canonical Brand Request create/list + SA review
            contract (reconcile with existing BrandReviewRequest documentation
            before implementation so two request concepts are not created).
          </p>
          <div style={{ marginTop: 16, display: "flex", gap: 12, flexWrap: "wrap" }}>
            <button
              type="button"
              className="bm-primary-btn"
              data-testid="brand-requests-goto-add-brand"
              onClick={() => navigate("/brand-manager/add-brand")}
            >
              Search catalog
            </button>
            <button
              type="button"
              className="bm-secondary-btn"
              data-testid="brand-requests-support-escape"
              onClick={() =>
                navigate(CLIENT_SUPPORT_HUB_PATH, {
                  state: {
                    prefillMessage:
                      "I need a Brand that is not in the KrossKast catalog yet.",
                  },
                })
              }
            >
              Contact Support (temporary)
            </button>
          </div>
        </div>
      </div>
    </BrandManagerShell>
  );
}
